import { canRunCoachMark } from '../../coach-mark/eligibility'

const loadCoachMark = () => import('../../coach-mark/coach-mark')

export async function maybeRunCoachMark({ ctx }) {
  if (!canRunCoachMark(ctx)) return
  const { default: CoachMarkRunner } = await loadCoachMark()
  CoachMarkRunner()
}
